import baseReport from '../baseReport';
import formatDataBR from '@/plugins/filters/formatDataBR';

const notificacoes = async ({ date, time, filtros, data }) => {debugger
  const headerFooter = await baseReport({ date, time, title: 'Administrativo', subTitle: 'Demonstrativo de Notificações' }, 'landscape');

  let dataFormated = []
  const observacao = []

  const filtrosFormated = [
      {
        text: filtros.nmescola,
        bold: true,
        fontSize: 12,
        alignment: 'center',
        margin: [0, 5, 0, 5],
      },
      {
        fontSize: 9,
        columns: [
          {
            text: [
              { text: 'Ano letivo:  ', bold: true },
              filtros.aaletivo
            ],
          },
        ],
      },
      {
        fontSize: 9,
        columns: [
          {
            text: [
              { text: 'Coordenador:  ', bold: true },
              `${filtros.cdpessoal}-${filtros.cdmatric} - ${filtros.nmfuncion}`
            ],
            margin: [0,0,0,15]
          },
        ],
      },
    ];

  if (data.length <= 0) {
    return {
      ...headerFooter,
      content: [
        ...filtrosFormated,
        {
          text: 'Nenhuma notificação encontrada.',
          fontSize: 10,
          alignment: 'center',
          margin: [0, 15, 0, 0],
          bold: true,
        }
      ]
    };
  }

  let turmas = new Map();

  let quantidade_pendentes = 0;
  let quantidade_resolvidas = 0;

  data.forEach( (notificacao) => {
    const turnos = {
      'V': 'Vespertino',
      'M': 'Matutino',
      'N': 'Noturno',
      'I': 'Integral'
    };

    notificacao.turma.nmturma = notificacao.turma.nmturma + ' - ' + turnos[notificacao.turma.cnperiodo];

    if (notificacao.indicasituacaonotificacao == 'R') quantidade_resolvidas += 1;
    else quantidade_pendentes += 1;

    if( !turmas.has(notificacao.turma.nmturma) ) turmas.set( notificacao.turma.nmturma, new Map() );

    if ( !turmas.get(notificacao.turma.nmturma).has(notificacao.disciplina.dsdiscipl) ) turmas.get(notificacao.turma.nmturma).set( notificacao.disciplina.dsdiscipl, [] );

    turmas.get(notificacao.turma.nmturma).get(notificacao.disciplina.dsdiscipl).push( {
      'professor': notificacao.professor.nmfuncion,
      'periodo_avaliativo': notificacao.periodo_avaliativo ? notificacao.periodo_avaliativo.dspravadi : 'Todos',
      'descricao_notificacao': notificacao.descricaonotificacao,
      'indica_situacao_notificacao': notificacao.indicasituacaonotificacao == 'R' ? 'Resolvido' : 'Pendente',
      'descricao_resposta': notificacao.descricaoresposta ? notificacao.descricaoresposta : null,
      'data_resposta': notificacao.dataresposta ? notificacao.dataresposta : null
    });
  });

  turmas = new Map([...turmas.entries()].sort( (a, b) => String(a[0]).localeCompare(b[0]) ));

  for ( let turma of turmas.keys() ) {
    turmas.get(turma).forEach( disciplina => {
      disciplina.sort( (a, b) => String(a.periodo_avaliativo).localeCompare(b.periodo_avaliativo) )
                .sort( (a, b) => String(a.professor).localeCompare(b.professor) );
    });

    turmas.set( turma, new Map( [...turmas.get(turma).entries()].sort( (a, b) => String(a[0]).localeCompare(b[0]) ) ) );
  }

  let tabelas = [];

  turmas.forEach( (valor, turma) => {

    tabelas.push([{text: `Turma: ${turma}`,bold: true, italics: true, fontSize: 10, margin: [0, 5, 0, 5]}]);

    valor.forEach( (valor, disciplina) => {

      let notificacoes = [];

      valor.forEach( (notificacao, index) => {
        notificacoes.push( [
          {text: notificacao.professor, fillColor: notificacao.indica_situacao_notificacao == 'Pendente' ? '#ff7878' : '#FFFFFF'},
            {text: notificacao.periodo_avaliativo, fillColor: notificacao.indica_situacao_notificacao == 'Pendente' ? '#ff7878' : '#FFFFFF'},
              {text: notificacao.descricao_notificacao, fillColor: notificacao.indica_situacao_notificacao == 'Pendente' ? '#ff7878' : '#FFFFFF'},
          {text: notificacao.indica_situacao_notificacao, fillColor: notificacao.indica_situacao_notificacao == 'Pendente' ? '#ff7878' : '#FFFFFF'},
          {text: notificacao.descricao_resposta, fillColor: notificacao.indica_situacao_notificacao == 'Pendente' ? '#ff7878' : '#FFFFFF'},
            {text: notificacao.data_resposta, fillColor: notificacao.indica_situacao_notificacao == 'Pendente' ? '#ff7878' : '#FFFFFF'}
          ]);
      });

      tabelas.push({
        margin: [0, 0, 0, 10],
        fontSize: 7,
        table: {
          widths: [{width:'auto'}, {width:'auto'}, {width:'*'}, {width:'auto'}, {width:'*'}, {width:'auto'}],
          body: [
            [{
              text: `Disciplina: ${disciplina}`,
              colSpan: 6,
              alignment: 'left',
              style: 'tableHeader',
            }, ...[{text:null}, {text:null}, {text:null}, {text:null}, {text:null}, ] ],
            [{text:'Professor', bold: true}, {text:'Período Avaliativo', bold: true}, {text:'Descriçção da Notificação', bold: true}, {text:'Situação', bold: true}, {text:'Descrição da Resposta', bold: true}, {text:'Data da Resposta', bold: true}],
            ...notificacoes
          ]
        }
      });

    });

  });

  tabelas.push({
    margin: [0, 10, 0, 10],
    fontSize: 7,
    table: {
      widths: [{width:'auto'}, {width:'*'}],
      body: [
        [ {text: 'Quantidade de Notificações:', style: 'tableHeader' }, {text: quantidade_pendentes + quantidade_resolvidas, style: 'tableHeader'} ],
        [ {text: 'Quantidade de Pendentes:', style: 'tableHeader' }, {text: quantidade_pendentes, style: 'tableHeader'} ],
        [ {text: 'Quantidade de Resolvidas:', style: 'tableHeader' }, {text: quantidade_resolvidas, style: 'tableHeader'} ],
      ],
    }
  });

  dataFormated = [tabelas];

  return {
    ...headerFooter,
    content: [
      ...filtrosFormated,
      ...dataFormated,
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 7,
        color: 'black',
        fillColor: '#D3D3D3'
      },
    }
  };
};

export default notificacoes;
